const dic: any = {
  stage: {
    politicsType: 'DT0000000149', // 政治面貌
    // educateStage: 'DT0000000190', // 教育阶段
    educateStage: 'DT0000000652', // 学位
    educateType: 'DT0000000156', // 学历选项
    learnFormId: 'DT0000000219', // 学习形式
    knowLevel: 'DT0000000165', // 技能掌握程度
    marriageState: 'DT0000000534', // 婚育状况
    applicationSource: 'DT0000000113', // 应聘信息来源
    applicationSourceOther: 'DT0000000413', // 应聘信息来源-其他
    documentType: 'DT0000000194', // 证件类型
    lookForStatus: 'DT0000000638', // 求职状态
    arrivalTimes: 'DT0000000656', // 到岗时间
    companyNature: 'DT0000000171', // 公司性质
    workNature: 'DT0000000666', // 工作性质
    companySize: 'DT0000000170', // 公司规模
    idCard: 'DT0000000195', // 身份证
    secondInterview: 'DT0000000403', // 二次应聘
    regularOther: 'DT0000000401', // 优工牛工特工转正
    regularPart: 'DT0000000402', // 兼职转正
    recruitSource: 'DT0000000558', // 应聘信息来源（校招简历投递）
    degreeType: 'DT0000000190', // 学位（校招简历投递）
    memberRelation: 'DT0000000717', // 家庭成员关系

  },
  prod: {
    politicsType: 'DT0000000122', // 政治面貌
    // educateStage: 'DT0000000141', // 教育阶段
    educateStage: 'DT0000000615', // 学位
    educateType: 'DT0000000113', // 学历选项
    learnFormId: 'DT0000000229', // 学习形式
    knowLevel: 'DT0000000189', // 技能掌握程度
    marriageState: 'DT0000000541', // 婚育状况
    applicationSource: 'DT0000000133', // 应聘信息来源
    applicationSourceOther: 'DT0000000228', // 应聘信息来源-其他
    documentType: 'DT0000000597', // 证件类型
    lookForStatus: 'DT0000000606', // 求职状态
    arrivalTimes: 'DT0000000610', // 到岗时间
    companyNature: 'DT0000000619', // 公司性质
    workNature: 'DT0000000646', // 工作性质
    companySize: 'DT0000000638', // 公司规模
    idCard: 'DT0000000598', // 身份证
    secondInterview: 'DT0000000218', // 二次应聘
    regularOther: 'DT0000000216', // 优工牛工特工转正
    regularPart: 'DT0000000217', // 兼职转正
    recruitSource: 'DT0000000550', // 应聘信息来源（校招简历投递）
    degreeType: 'DT0000000141', // 学位（校招简历投递）
    memberRelation: 'DT0000000685', // 家庭成员关系
  }
}
// const env = 'stage'
const env = 'prod'


export const dictionary = dic[env];

export function getDictionary() {
  const env = process.env.VUE_APP_ENV;
  const dictionary = dic[env];
  return dictionary;
}